import { api } from "../App";
import { SET_ORDERS_LIST, SET_SPEC_FIELDS, SET_SPECS_VALUES, SET_SPECS, SET_SPEC_TYPES_LIST, SET_ORDERS_LOADING } from "./types";


export const getOrdersList = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    const { data } = await api.get(`/orders`);
    dispatch({ type: SET_ORDERS_LIST, payload: data.data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
  }
}

export const createOrder = (data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    await api.post(`/orders`, data);
    await dispatch(getOrdersList())
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
    return success
  }
}
export const updateOrder = ({ idorder, ...data }) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    await api.put(`/orders/${idorder}`, data);
    await dispatch(getOrdersList())
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
    return success
  }
}

export const deleteOrder = (idorder) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    await api.delete(`/orders/${idorder}`);
    await dispatch(getOrdersList())
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
  }
}

//ТАБЛИЦА СПЕЦИФИКАЦИИ ПРИКАЗА
export const getOrderSpecs = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    const { data } = await api.get(`/orders/${id}/specs`);
    dispatch({ type: SET_SPECS, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
  }
}
// получение полей для модалки изменения СПЕЦИФИКАЦИИ ПРИКАЗА
export const getSpecFields = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    const { data } = await api.get(`/orders/${id}/fields`);
    dispatch({ type: SET_SPEC_FIELDS, payload: data.data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
  }
}

//получение значений для модалки изменения СПЕЦИФИКАЦИИ ПРИКАЗА ( id = сущест-й спецификации)
export const getSpecsValues = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    const { data } = await api.get(`/orders/specs/${id}`);
    dispatch({ type: SET_SPECS_VALUES, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
  }
}

//СПИСОК типов спецификации приказов (выпадашка в модалке )
export const getSpecTypesList = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    const { data } = await api.get(`/orders/types`);
    dispatch({ type: SET_SPEC_TYPES_LIST, payload: data.data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
  }
}

export const createOrderSpec = (idorder, data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    await api.post(`/orders/${idorder}/specs`, data);
    await dispatch(getOrderSpecs(idorder))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
    return success
  }
}
export const updateOrderSpec = ({ idorderspec, idorder, ...data }) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    await api.put(`/orders/specs/${idorderspec}`, data);
    await dispatch(getOrderSpecs(idorder))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
    return success
  }
}

export const deleteOrderSpec = (idorder, idorderspec) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_ORDERS_LOADING, payload: true });
    await api.delete(`/orders/specs/${idorderspec}`);
    await dispatch(getOrderSpecs(idorder))
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ORDERS_LOADING, payload: false });
  }
}

// export const updateTypeOfDocument = ({ xp_key, ...data }) => async (dispatch, getState) => {
//   let success
//   try {
//     dispatch({ type: SET_ORDERS_LOADING, payload: true });
//     await api.put(`/orders/${xp_key}`, data);
//     await dispatch(getOrdersList())
//     success = true
//   } catch (ERR) {
//   } finally {
//     dispatch({ type: SET_ORDERS_LOADING, payload: false });
//     return success
//   }
// }

